import React, { useState, useEffect } from "react";
import Modal from "components/base/Modal";
import classNames from "classnames";
import css from "../style.scss";

const EndCampaignModal = ({ isOpen, onClose, onConfirm, active }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    return (
        <>
            <Modal
                isOpen={isOpen}
                onClose={onClose}
                uniqId="EndCampaign"
                width="auto"
                padding="0"
                modalClassName={css.pricingModal}
                className={classNames(css.clsAccPageModals, css.clsBillingModal)}
            >
                <div className={classNames(css.modal_lg, "modal-dialog modal-lg m-0 modal-dialog-scrollable")}>
                    <div className={classNames(css.clsModalContent, "modal-content")}>
                        <div className={classNames(css.removeBatchDialerModal, "modal-body")}>
                            <div className={css.rbModalTextGroup}>
                                <div className={css.rbModalTitle}>{active ? "End Campaign" : "Reinstate Campaign"}</div>
                                <div className={css.rbModalDetails}>
                                    {active ?
                                        <span>This will deactivate all active campaign activities.  <br></br> Your campaign data and past activities will remain <br></br>saved for future reference.</span>
                                        :
                                        <span>Your campaign will be reinstated. After<br></br>reinstatement, you can use all available features<br></br>and manage the campaign just as you would any<br></br>other active campaign.</span>
                                    }
                                </div>
                            </div>

                            <div className={css.buttonRemoveWrapper}>
                                <button className={css.cancelRemoveBtn} onClick={onClose}>
                                    <span className={css.cancelRemoveLabel}>Cancel</span>
                                </button>
                                <button className={classNames(active ? css.connectModalRmvBtn : css.connectBtn, { [css.noClick]: isSubmitting })} onClick={onConfirm}>
                                    <span className={css.connectRmvBtnLabel}>{active ? "End Campaign" : "Reinstate Campaign"}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default EndCampaignModal;